export var Name = 'banner-data-loaded';
export var ProductDataLoadedEvent = Name;